import { Collapse } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import API from 'api';
import { QUERY_KEYS } from 'api/certificates/queries';
import { DOCUMENT_TYPE, DocumentModel } from 'api/documents/documents.model';
import Table from 'components/Table';
import { CertificateDetailsModel } from 'models/certificate.model';
import { CATEGORY_TYPE } from 'models/documents.model';

import * as Styled from './Drafts.styles';

const Drafts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data = [],
    isLoading,
    refetch: fetchDrafts,
  } = useQuery(
    QUERY_KEYS.GET_DRAFTS,
    () =>
      API.documents.getDocuments<CertificateDetailsModel>({
        documentType: DOCUMENT_TYPE.PUBLIC,
        draft: true,
      }),
    { enabled: false, useErrorBoundary: true }
  );

  const { Panel } = Collapse;

  const certificatesTableConfig: ColumnsType<DocumentModel<CertificateDetailsModel>> = [
    {
      title: t('certificate.typeOfCertificate'),
      dataIndex: 'category',
      render: (item: CATEGORY_TYPE) =>
        t(item !== CATEGORY_TYPE.CERTIFICATE ? `certificate.${item}` : 'certificate.default'),
    },
    {
      title: t('certificate.certificateUID'),
      dataIndex: ['additionalDetails', 'productId'],
    },
    {
      title: t('certificate.company'),
      dataIndex: ['additionalDetails', 'company'],
    },
  ];

  return (
    <Styled.Drafts>
      <Styled.Divider />
      <Collapse ghost accordion onChange={(key) => key && fetchDrafts()}>
        <Panel header="Drafts" key={1}>
          <Table
            data={data}
            isLoading={isLoading}
            config={certificatesTableConfig}
            onRowClick={(draft) => navigate(`/home/draft/${draft.jobId}`)}
            rowKey={({ jobId }) => jobId}
          />
        </Panel>
      </Collapse>
      <Styled.Divider />
    </Styled.Drafts>
  );
};

export default Drafts;
